import { render, staticRenderFns } from "./CompraDividaMenu.vue?vue&type=template&id=674e1952&scoped=true&"
import script from "./CompraDividaMenu.vue?vue&type=script&lang=js&"
export * from "./CompraDividaMenu.vue?vue&type=script&lang=js&"
import style0 from "./CompraDividaMenu.vue?vue&type=style&index=0&id=674e1952&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674e1952",
  null
  
)

export default component.exports